import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { PlanType, SubscriptionStatus } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'subscription-status',
  templateUrl: './subscription-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class SubscriptionStatusComponent implements OnInit {
  private cd = inject(ChangeDetectorRef);

  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);
  type!: any;
  ngOnInit() {
    this.columnData.subscribe({
      next: (item: any) => {
        this.setPlanType(item);
      },
    });
  }
  setPlanType(cData: any) {
    if (cData?.clt_subs_status) {
      this.type =
        SubscriptionStatus[
          cData?.clt_subs_status as keyof typeof SubscriptionStatus
        ];
    } else if (cData?.status) {
      this.type = cData?.status;
    }
  }
}
